import { EventEmitter } from 'events';

/* tslint:disable:no-console */

declare var gapi: any;

const CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID;
const API_KEY = process.env.VUE_APP_GOOGLE_API_KEY;
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];
const SCOPES = 'https://www.googleapis.com/auth/drive.file';

export default class GoogleDrive extends EventEmitter {

    private directory: { name: string, id: string};
    private profile: any = undefined;

    public constructor(directory: string) {
        super();
        this.directory = { name: directory, id: ''};
        gapi.load('client:auth2', () => {
            gapi.client.init({
                apiKey: API_KEY,
                clientId: CLIENT_ID,
                discoveryDocs: DISCOVERY_DOCS,
                scope: SCOPES,
            }).then(() => {
                gapi.auth2.getAuthInstance().isSignedIn.listen(this.updateSigninStatus.bind(this));
                this.updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
            }, (error: any) => {
                console.log('gapi.load error');
                console.log(error);
            });
        });
    }

    public authorize() {
        gapi.auth2.getAuthInstance().signIn( {
            prompt: 'select_account',
        } );
    }

    public signOut() {
        gapi.auth2.getAuthInstance().signOut();
    }

    public updateSigninStatus(isSignedIn: boolean) {
        console.log(`Signin status changed: ${isSignedIn}`);

        if (isSignedIn) {
            this.profile = gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile();
            this.getDirectoryId(this.directory.name)
            .then( (id: string) => {
                this.directory.id = id;
            });
        } else {
            this.profile = undefined;
            this.directory.id = '';
        }
        this.emit('profileUpdate', this.getCurrentUser());
    }

    public uploadSenTiLabFile(name: string, content: any) {
        return this.uploadFile(this.directory.id, name, content);
        // return new Promise((resolve, reject) => {
        //     this.getFileId(name)
        //     .then( (id: any) => {
        //         if ( id === undefined ) {
        //             console.log('file does not exist');
        //             resolve(this.uploadFile(this.directory.id, name, content));
        //         } else {
        //             resolve(id);
        //         }
        //     })
        //     .catch( (err: any) => {
        //         reject(err);
        //     });
        // });
    }

    public uploadFile(parentId: string, name: string, content: any) {
        return new Promise((resolve, reject) => {
            const fileMetadata = {
                name,
                mimeType: 'application/vnd.google-apps.spreadsheet',
                parents: [parentId],
            };

            const accessToken = gapi.auth.getToken().access_token; // Here gapi is used for retrieving the access token.
            const form = new FormData();
            form.append('metadata', new Blob([JSON.stringify(fileMetadata)], {type: 'application/json'}));
            form.append('file', content);

            const xhr = new XMLHttpRequest();
            xhr.open('post', 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart');
            xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
            xhr.responseType = 'json';
            xhr.onload = () => {
                console.log(xhr.response);
                resolve(xhr.response.id); // Retrieve uploaded file ID.
            };
            xhr.send(form);
        });
    }

    public getDirectoryId(directory: string): Promise<string> {
        return new Promise((resolve, reject) => {
            gapi.client.drive.files.list({
                q: `mimeType='application/vnd.google-apps.folder' and trashed=false and name='${directory}'`,
                fields: 'files(id, name)',
            }).then((response: any) => {
                if (response.status === 200) {
                    if (response.result.files.length !== 0) {
                        resolve(response.result.files[0].id);
                    } else {
                        this.createDirectory(directory)
                        .then( (id) => resolve(id as string));
                    }
                } else {
                    reject(response);
                }
            });
        });
    }

    public createDirectory(directory: string) {
        return new Promise((resolve, reject) => {
            const fileMetadata = {
                name: 'SenTiLab',
                mimeType: 'application/vnd.google-apps.folder',
            };
            gapi.client.drive.files.create({
                resource: fileMetadata,
            }).then((response: any) => {
                console.log(response);
                if (response.status === 200) {
                    resolve(response.result.id);
                } else {
                    reject(response);
                }
            });
        });
    }

    // public getFileId(file: string) {
    //     return new Promise((resolve, reject) => {
    //         console.log(file);
    //         gapi.client.drive.files.list({
    //             q: `name='${file}' and '${this.directory.id}' in parents`,
    //             fields: 'files(id, name)',
    //         }).then((response: any) => {
    //             console.log(response);
    //             if (response.status === 200) {
    //                 if (response.result.files.length !== 0) {
    //                     resolve(response.result.files[0].id);
    //                 }
    //                 resolve();
    //             }
    //             reject(response);
    //         });
    //     });
    // }

    public getCurrentUser() {
        if (this.profile) {
            return { name: this.profile.getName(), email: this.profile.getEmail(), avatar: this.profile.getImageUrl() };
        }
        return null;
    }
}
